import React, { ReactNode } from 'react';

import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './InfoItem.module.scss';

type InfoItemProps = {
  title: string;
  description?: string;
  value?: ReactNode;
};

const InfoItem = ({ title, description, value }: InfoItemProps) => {
  return (
    <div className={classes.container}>
      <TitleWithDescription
        titleFont="body-14-bold"
        title={title}
        description={description && <p className={classes.description}>{description}</p>}
      />
      {value}
    </div>
  );
};

export { InfoItem };
